<template>
  <v-menu
    v-ripple
    bottom
    right
    content-class="dropdown-menu"
    offset-y
    transition="slide-y-transition"
    class="pa-0"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        icon
        class="ma-0 horn"
        title="アナウンス"
        v-on="on"
      >
        <v-icon color="tertiary">
          mdi-bullhorn
        </v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-list two-line>
        <v-list-tile
          to="/release-notes"
        >
          <v-list-tile-content>
            <v-list-tile-sub-title class="date">
              {{ releaseNotes[0].date }}
            </v-list-tile-sub-title>
            <v-list-tile-title class="note">
              バージョン{{ releaseNotes[0].version }}をリリースしました
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-card>
  </v-menu>
</template>

<script>
import releaseNotes from '@/contents/announces/releaseNotes.json'
export default {
  data () {
    return {
      releaseNotes
    }
  }
}
</script>

<style lang="scss" scoped>
.horn {
  border-radius: 50%;
  transition: box-shadow .2s ease-out;

  &:hover, &:focus {
    box-shadow: 0px 0px 0px 1px #888 !important;
  }
}

.note {
  font-size: 0.85rem;
}
.date {
  font-size: 0.7rem;
}
</style>
